module.exports = __webpack_public_path__ + "static/media/corrin-win.bf38973d.png";